import { render } from "./editOrder.vue?vue&type=template&id=c2454e5a&scoped=true"
import script from "./editOrder.vue?vue&type=script&lang=js"
export * from "./editOrder.vue?vue&type=script&lang=js"

import "./editOrder.vue?vue&type=style&index=0&id=c2454e5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2454e5a"]])

export default __exports__